import React from 'react';

const Footer = () => {
  return (
    <footer>
        <h5 className="text-center">
          Copyright ©2020| Yeraldith Camargo Ayala
        </h5>
    </footer>
  );
}
export default Footer